export enum AccountType {
  Solo = 'solo',
  Company = 'company',
}
